import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import ContentfulVue from 'contentful-vue';
import VueScrollTo from "vue-scrollto";

Vue.use(VueScrollTo);

Vue.use(ContentfulVue, {
	space: "94ounxwxp3q6",
	accessToken: "4cb5dc7f0779268e1eda08c889f6f8a8efa3927437e56e7370addf14989ea994"
});

Vue.config.productionTip = false
Vue.config.devtools = true;

new Vue({
	router,
	store,
	render: h => h(App),
	created () {
		//@TODO fix server redirects
		if (sessionStorage.redirect) {
			const redirect = sessionStorage.redirect
			delete sessionStorage.redirect
			this.$router.push(redirect)
		}
	}
}).$mount('#app')
